<!-- Collapsed State - Enabled (clickable to expand) -->
<div *ngIf="!isExpanded || disabled"
     (click)="onCollapsedClick($event)"
     class="px-3 py-2 text-sm cursor-text hover:border-gray-400 transition-colors"
     [ngClass]="collapsedContainerClass"
     [class.cursor-not-allowed]="disabled"
     [class.opacity-50]="disabled"
     [ngClass]="collapsedClass">
    <div [class.line-clamp-1]="enableTruncate" [class.hover:line-clamp-none]="enableTruncate">
        <span [innerHTML]="collapsedPreview"></span>
    </div>
</div>

<!-- Expanded State -->
<div *ngIf="isExpanded" class="w-full bg-gray-50 border-2 border-gray-200 rounded-lg p-3">
    <!-- Markdown Toolbar -->
    <div class="flex flex-nowrap gap-1 p-1.5 bg-gray-100 rounded-t-md border-b-2 border-gray-200 relative items-center">
        <!-- Text Formatting -->
        <button type="button" (click)="insertMarkdown('**', '**')" [disabled]="disabled"
                [class.!bg-[#00a651]]="isBold" [class.!border-[#00a651]]="isBold" [class.!text-white]="isBold"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0" title="Bold">
            <strong>B</strong>
        </button>
        <button type="button" (click)="insertMarkdown('*', '*')" [disabled]="disabled"
                [class.!bg-[#00a651]]="isItalic" [class.!border-[#00a651]]="isItalic" [class.!text-white]="isItalic"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0" title="Italic">
            <em>I</em>
        </button>
        <button type="button" (click)="insertMarkdown('<u>', '</u>')" [disabled]="disabled"
                [class.!bg-[#00a651]]="isUnderline" [class.!border-[#00a651]]="isUnderline" [class.!text-white]="isUnderline"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0" title="Underline">
            <u>U</u>
        </button>

        <div class="w-px h-6 bg-gray-300 mx-1 flex-shrink-0"></div>

        <!-- Lists -->
        <button type="button" (click)="insertList('bulleted')" [disabled]="disabled"
                [class.!bg-[#00a651]]="listMode === 'bulleted' || isInBulletedList" [class.!border-[#00a651]]="listMode === 'bulleted' || isInBulletedList" [class.!text-white]="listMode === 'bulleted' || isInBulletedList"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0" title="Bulleted List">
            <mat-icon class="!text-base !w-4 !h-4 !leading-4">format_list_bulleted</mat-icon>
        </button>
        <button type="button" (click)="insertList('numbered')" [disabled]="disabled"
                [class.!bg-[#00a651]]="listMode === 'numbered' || isInNumberedList" [class.!border-[#00a651]]="listMode === 'numbered' || isInNumberedList" [class.!text-white]="listMode === 'numbered' || isInNumberedList"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0" title="Numbered List">
            <mat-icon class="!text-base !w-4 !h-4 !leading-4">format_list_numbered</mat-icon>
        </button>

        <div class="w-px h-6 bg-gray-300 mx-1 flex-shrink-0"></div>

        <!-- Links & Tables -->
        <button type="button" (click)="insertMarkdown('[', '](url)')" [disabled]="disabled"
                [class.!bg-[#00a651]]="isLink" [class.!border-[#00a651]]="isLink" [class.!text-white]="isLink"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0" title="Link">
            <mat-icon class="!text-base !w-4 !h-4 !leading-4">link</mat-icon>
        </button>
        <div class="relative flex-shrink-0">
            <button type="button" (click)="toggleTableSelector($event)" [disabled]="disabled"
                    class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed" title="Insert Table">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">table_chart</mat-icon>
            </button>
            <!-- Table Size Selector -->
            <div *ngIf="showTableSelector" class="fixed bg-white border border-gray-300 rounded-lg shadow-xl p-3 z-[9999]" 
                 [ngClass]="['!top-[' + tableSelectorPosition.top + 'px]', '!left-[' + tableSelectorPosition.left + 'px]']">
                <div class="text-xs font-semibold mb-2 text-gray-700">Insert Table</div>
                <div class="grid grid-cols-8 gap-0.5 mb-2">
                    <ng-container *ngFor="let row of [1,2,3,4,5,6,7,8]">
                        <div *ngFor="let col of [1,2,3,4,5,6,7,8]"
                             (mouseenter)="onTableCellHover(row, col)"
                             (click)="insertTableWithSize(row, col)"
                             [class.bg-blue-400]="hoveredTableCell && row <= hoveredTableCell.row && col <= hoveredTableCell.col"
                             class="w-4 h-4 border border-gray-400 cursor-pointer hover:bg-blue-200 transition-colors"></div>
                    </ng-container>
                </div>
                <div class="text-xs text-center text-gray-600">
                    {{ hoveredTableCell ? hoveredTableCell.row + ' x ' + hoveredTableCell.col : '1 x 1' }}
                </div>
            </div>
        </div>

        <div class="w-px h-6 bg-gray-300 mx-1 flex-shrink-0"></div>

        <!-- History -->
        <button type="button" (click)="undo()" [disabled]="disabled || !canUndo"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0" title="Undo">
            <mat-icon class="!text-base !w-4 !h-4 !leading-4">undo</mat-icon>
        </button>
        <button type="button" (click)="redo()" [disabled]="disabled || !canRedo"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0" title="Redo">
            <mat-icon class="!text-base !w-4 !h-4 !leading-4">redo</mat-icon>
        </button>

        <div class="w-px h-6 bg-gray-300 mx-1 flex-shrink-0"></div>

        <!-- More Formatting Options Menu -->
        <button type="button"
                [matMenuTriggerFor]="formattingMenu"
                [disabled]="disabled"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-gray-700 hover:bg-gray-50 hover:border-[#00a651] hover:text-[#00a651] transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
                title="More Formatting">
            <mat-icon class="!text-base !w-4 !h-4 !leading-4">more_horiz</mat-icon>
        </button>
        <mat-menu #formattingMenu="matMenu" class="!max-h-[400px] !bg-white">
            <button mat-menu-item type="button" (click)="insertMarkdown('~~', '~~')" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">strikethrough_s</mat-icon>
                <span class="ml-2">Strikethrough</span>
            </button>
            <button mat-menu-item type="button" (click)="insertMarkdown('`', '`')" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">code</mat-icon>
                <span class="ml-2">Code</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item type="button" (click)="toggleHighlightColorPicker()" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">highlight</mat-icon>
                <span class="ml-2">Highlight</span>
            </button>
            <button mat-menu-item type="button" (click)="toggleTextColorPicker()" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">format_color_text</mat-icon>
                <span class="ml-2">Text Color</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item type="button" (click)="changeIndent('decrease')" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">format_indent_decrease</mat-icon>
                <span class="ml-2">Decrease Indent</span>
            </button>
            <button mat-menu-item type="button" (click)="changeIndent('increase')" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">format_indent_increase</mat-icon>
                <span class="ml-2">Increase Indent</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item type="button" (click)="insertMarkdown('> ', '')" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">format_quote</mat-icon>
                <span class="ml-2">Quote</span>
            </button>
            <button mat-menu-item type="button" (click)="insertParagraph()" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">notes</mat-icon>
                <span class="ml-2">Paragraph</span>
            </button>
            <button mat-menu-item type="button" (click)="insertHorizontalRule()" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">horizontal_rule</mat-icon>
                <span class="ml-2">Horizontal Rule</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item type="button" (click)="insertTableRow()" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">table_rows</mat-icon>
                <span class="ml-2">Insert Row</span>
            </button>
            <button mat-menu-item type="button" (click)="deleteTableElement()" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">delete_outline</mat-icon>
                <span class="ml-2">Delete Table/Row/Column</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item type="button" (click)="clearFormatting()" [disabled]="disabled">
                <mat-icon class="!text-base !w-4 !h-4 !leading-4">format_clear</mat-icon>
                <span class="ml-2">Clear Formatting</span>
            </button>
            <!-- Extra Actions from Parent -->
            <ng-container *ngIf="extraActions && extraActions.length > 0">
                <mat-divider></mat-divider>
                <button *ngFor="let extraAction of extraActions"
                        mat-menu-item
                        type="button"
                        (click)="extraAction.action()"
                        [disabled]="extraAction.disabled">
                    <mat-icon class="!text-base !w-4 !h-4 !leading-4">{{ extraAction.icon }}</mat-icon>
                    <span class="ml-2">{{ extraAction.title }}</span>
                </button>
            </ng-container>
        </mat-menu>

        <!-- Color Pickers (shown when triggered from menu) -->
        <div *ngIf="showHighlightColorPicker" class="fixed bg-white border border-gray-300 rounded-lg shadow-lg p-2 z-[9999] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <div class="text-xs font-semibold mb-2 text-gray-700">Select Highlight Color</div>
            <div class="grid grid-cols-6 gap-1">
                <button *ngFor="let color of suggestedColors" type="button" (click)="applyHighlightColor(color)"
                        [ngClass]="['!bg-[' + color + ']']"
                        class="w-6 h-6 rounded border border-gray-300 hover:scale-110 transition-transform cursor-pointer"
                        [title]="color"></button>
            </div>
        </div>
        <div *ngIf="showTextColorPicker" class="fixed bg-white border border-gray-300 rounded-lg shadow-lg p-2 z-[9999] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            <div class="text-xs font-semibold mb-2 text-gray-700">Select Text Color</div>
            <div class="grid grid-cols-8 gap-1">
                <button *ngFor="let color of textColors" type="button" (click)="applyTextColor(color)"
                        [ngClass]="['!bg-[' + color + ']']"
                        class="w-5 h-5 rounded border border-gray-300 hover:scale-110 transition-transform cursor-pointer"
                        [title]="color"></button>
            </div>
        </div>

        <div class="flex-1 flex-shrink"></div>

        <!-- Clear Text -->
        <button type="button" (click)="clearText()" [disabled]="disabled"
                class="px-2.5 py-1.5 bg-white border border-gray-200 rounded text-xs text-red-600 hover:bg-red-50 hover:border-red-500 transition-all flex items-center gap-1 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0"
                title="Clear Text">
            <mat-icon class="!text-base !w-4 !h-4 !leading-4">cleaning_services</mat-icon>
        </button>
        <!-- Preview Toggle -->
        <div class="flex items-center gap-2 mt-[4px] ml-[5px]">
            <input type="checkbox" id="preview-checkbox" [(ngModel)]="showPreview" (change)="onPreviewToggle()" class="w-[18px] h-[18px] cursor-pointer appearance-auto" name="showPreview">
            <label for="preview-checkbox" class="text-sm font-medium text-gray-700 cursor-pointer">Show Preview</label>
        </div>
    </div>

    <!-- Content Textarea -->
    <div class="relative">
        <textarea #contentTextarea [(ngModel)]="decodedContent" (ngModelChange)="onContentChange($event, false, $event)"
                  [class.overflow-auto]="enableScroll"
                  [class.overflow-hidden]="!enableScroll"
                  [class.h-auto]="!enableScroll"
                  [ngClass]="!enableScroll ? ['!min-h-[' + (rows * 1.5) + 'rem]'] : []"
                  class="w-full border border-gray-200 relative rounded-lg p-2.5 text-sm resize-vertical mb-2.5 focus:outline-none focus:outline-2 focus:outline-black focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed" [placeholder]="placeholder"
                  (blur)="onBlur()">
        </textarea>
        <span #placeholdersTrigger="matMenuTrigger" [matMenuTriggerFor]="placeholdersMenu" [ngClass]="'!left-[' + menuPosition.x + 'px] !top-[' + menuPosition.y + 'px]'" class="absolute opacity-0 pointer-events-none -translate-x-1/2"></span>
    </div>
    <!-- Markdown Preview -->
    <div *ngIf="showPreview"
         [class.overflow-auto]="enableScroll"
         [class.overflow-hidden]="!enableScroll"
         class="p-2.5 border border-gray-200 rounded-lg min-h-[80px] bg-white text-sm leading-relaxed mb-2.5" [innerHTML]="markdownPreview">
    </div>

    <!-- Color Pickers (shown when triggered from menu) -->
    <div *ngIf="showHighlightColorPicker" class="fixed bg-white border border-gray-300 rounded-lg shadow-lg p-2 z-[9999] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div class="text-xs font-semibold mb-2 text-gray-700">Select Highlight Color</div>
        <div class="grid grid-cols-6 gap-1">
            <button *ngFor="let color of suggestedColors" type="button" (click)="applyHighlightColor(color)"
                    [ngClass]="['!bg-[' + color + ']']"
                    class="w-6 h-6 rounded border border-gray-300 hover:scale-110 transition-transform cursor-pointer"
                    [title]="color"></button>
        </div>
    </div>
    <div *ngIf="showTextColorPicker" class="fixed bg-white border border-gray-300 rounded-lg shadow-lg p-2 z-[9999] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div class="text-xs font-semibold mb-2 text-gray-700">Select Text Color</div>
        <div class="grid grid-cols-8 gap-1">
            <button *ngFor="let color of textColors" type="button" (click)="applyTextColor(color)"
                    [ngClass]="['!bg-[' + color + ']']"
                    class="w-5 h-5 rounded border border-gray-300 hover:scale-110 transition-transform cursor-pointer"
                    [title]="color"></button>
        </div>
    </div>

    <!-- Comment Actions -->
    <div *ngIf="commentActions && commentActions?.length > 0">
        <div class="flex gap-2 justify-end" *transloco="let translate;">
            <div *ngFor="let action of commentActions" class="flex gap-2 justify-end mt-[25px]">
                <material-button *ngIf="action.type === 'ATTACHMENT'" class="attachButton"
                                 [buttonType]="'icon'"
                                 [text]="translate(action.title)"
                                 [titleText]="translate(action.title)"
                                 [prefixIcon]="action.icon"
                                 [hideRipple]="true"
                                 prefixIconType="material"
                                 [textClassList]="['text-black', 'font-bold']"
                                 [prefixIconClassList]="['!rotate-45', '!mr-[5px]']"
                                 (buttonClicked)="$event.preventDefault();fileInput.click()">
                </material-button>
                <input #fileInput type="file" multiple (change)="attachClick.emit($event);action.action($event)" hidden>
                <material-button *ngIf="action.type === 'BUTTON'"
                                 color="primary"
                                 [classList]="['!px-[26px]','!py-[21px]', '!rounded-[10px]']"
                                 size="medium"
                                 [text]="translate(action.title)"
                                 [titleText]="translate(action.title)"
                                 [prefixIconClassList]="['!mr-[5px]']"
                                 [textClassList]="['!font-bold']"
                                 [prefixIconAppearance]="'filled'"
                                 [prefixIcon]="action.icon"
                                 prefixIconType="material"
                                 (buttonClicked)="action.action()">
                </material-button>
            </div>
        </div>
    </div>
</div>

<!-- Placeholders Menu -->
<mat-menu #placeholdersMenu="matMenu"
          class="placeholders-menu"
          [overlapTrigger]="false"
          (menuOpened)="onMenuOpened()"
          (menuClosed)="onMenuClosed()">
    <div class="p-3 w-[400px] max-w-[90vw]">
        <h3 class="text-sm font-medium text-gray-700 mb-2">Available Placeholders (Ctrl+Space) Or type "&#123;"</h3>
        <div class="space-y-2 max-h-[300px] overflow-y-auto" role="listbox">
            <button mat-menu-item
                    *ngFor="let item of availablePlaceholders; let i = index"
                    (click)="insertPlaceholder(item.value, i)"
                    (keydown.arrowup)="onPlaceholderKeyEvent($event, i, 'up'); $event.stopPropagation()"
                    (keydown.arrowdown)="onPlaceholderKeyEvent($event, i, 'down'); $event.stopPropagation()"
                    (keydown.enter)="$event.preventDefault(); insertPlaceholder(item.value, i)"
                    (keydown.space)="$event.preventDefault(); insertPlaceholder(item.value, i)"
                    (keydown.escape)="$event.preventDefault(); insertPlaceholder(item.value, -2)"
                    [class.bg-blue-50]="selectedPlaceholderIndex === i"
                    [class.mat-menu-item-highlighted]="selectedPlaceholderIndex === i"
                    [class.selected]="selectedPlaceholderIndex === i"
                    [attr.data-index]="i"
                    [attr.aria-selected]="selectedPlaceholderIndex === i"
                    [attr.tabindex]="selectedPlaceholderIndex === i ? '0' : '-1'"
                    role="menuitem"
                    class="placeholder-item !text-sm !h-auto !py-2 !px-3"
                    [ngClass]="selectedPlaceholderIndex === i ? '!bg-[#eff6ff]' : '!bg-transparent'">
                <div class="flex flex-col w-full">
                    <div class="flex justify-between items-center">
                        <span class="font-medium text-gray-900" [class.font-semibold]="selectedPlaceholderIndex === i">{{item.label}}</span>
                        <code class="text-xs bg-gray-100 px-2 py-1 rounded">{{item.value}}</code>
                    </div>
                    <span class="text-xs text-gray-500 mt-1 text-left">{{item.description}}</span>
                </div>
            </button>
        </div>
    </div>
</mat-menu>
